<template>
  <form class="p-2" @submit.prevent="handleAddItem">
    <ModalContainer :show="show" @close="onCancel">
      <template slot="header">
        <h4 class="mb-0 text-capitalize">
          {{ isEdit ? $t("edit_item") : $t("add_item") }}
        </h4>
      </template>

      <template slot="body">
        <div class="d-flex align-items-center col-gap-1">
          <div class="form-group w-100">
            <label for="fullname">{{ $t("delivery_date/time") }}</label>
            <input
              type="datetime-local"
              v-model="item.deliveryDate"
              class="form-control"
              required
              id="fullname"
              :min="minDeliveryDate"
            />
          </div>

          <div class="form-group w-100">
            <label for="fullname">{{ $t("item_name") }}</label>
            <input
              type="text"
              v-model="item.name"
              class="form-control"
              required
              id="fullname"
            />
          </div>
        </div>

        <div class="d-flex align-items-center col-gap-1">
          <div
            class="form-group w-100 position-relative"
            v-click-outside="closeWeightUom"
          >
            <label for="fullname"
              >{{ $t("weight") }} {{ $t("optional") }}</label
            >
            <input
              type="number"
              step="any"
              v-model.number="item.weight"
              class="form-control"
              id="fullname"
              style="padding-right: 5rem"
            />
            <div
              class="dropdown-unit position-absolute d-flex align-items-center cursor-pointer"
              @click="isOpen = !isOpen"
            >
              <span class="gray4">{{ item.weightUOM }}</span>
              <arrow-down />
            </div>

            <!-- dropdown -->
            <ul v-if="isOpen" class="dropdown-list" style="min-width: 8rem">
              <li
                v-for="weight in weightUOMList"
                :key="weight"
                class="dropdown-item"
                @click="
                  item.weightUOM = weight;
                  isOpen = false;
                "
              >
                {{ weight }}
              </li>
            </ul>
          </div>

          <div class="form-group w-100">
            <label for="quantity"
              >{{ $t("quantity") }} {{ $t("optional") }}</label
            >
            <input
              type="text"
              v-model.number="item.quantity"
              class="form-control"
              id="quantity"
              @keypress="IsNumber($event)"
              inputmode="numeric"
            />
          </div>
        </div>

        <div class="d-flex align-items-center col-gap-1">
          <div
            class="form-group w-100 position-relative"
            v-click-outside="closeCurrency"
          >
            <label for="fullname">{{ $t("Price") }} {{ $t("optional") }}</label>
            <input
              type="text"
              v-model.number="item.price"
              class="form-control"
              id="fullname"
              @keypress="IsNumber($event)"
              inputmode="numeric"
              style="padding-left: 80px"
            />
            <div
              class="dropdown-unit position-absolute d-flex align-items-center"
              style="right: unset; left: 6px"
              @click="toggleCurrency"
              :class="{ 'cursor-pointer': canUpdateCurrency }"
            >
              <component :is="currentFlag" />
              <span class="gray4">{{ currency }}</span>
              <arrow-down />
            </div>

            <!-- dropdown -->
            <ul
              v-if="isOpenCurrency"
              class="dropdown-list"
              style="min-width: 8rem; left: 0; right: unset"
            >
              <li
                v-for="singleCurrency in currencies"
                :key="singleCurrency.code"
                class="dropdown-item"
                @click="
                  currency = singleCurrency.code;
                  isOpenCurrency = false;
                "
              >
                <component :is="singleCurrency.flag" class="mr-2" />
                {{ singleCurrency.code }}
              </li>
            </ul>
          </div>
          <div class="form-group w-100">
            <label for="fullname">{{ $t("description_optional") }}</label>
            <input
              type="text"
              name="name"
              v-model="item.description"
              class="form-control"
              id="fullname"
            />
          </div>
        </div>
      </template>
      <template slot="footer">
        <div style="display: flex; justify-content: end">
          <button type="submit" class="btn btn-primary text-capitalize">
            {{ $t("add") }}
          </button>
        </div>
      </template>
    </ModalContainer>
  </form>
</template>

<script>
import ArrowDown from "../../../components/Iconsvg/ArrowDown.vue";
import ModalContainer from "../../../components/ModalContainer.vue";
import NaijaFlag from "../../../assets/svg/NaijaFlag.vue";
import KenyaFlag from "../../../assets/svg/KenyaFlag.vue";
import UsaFlag from "../../../assets/svg/UsaFlag.vue";

export default {
  name: "AddItemModal",
  components: {
    ModalContainer,
    ArrowDown,
    NaijaFlag,
    KenyaFlag,
    UsaFlag,
  },
  props: {
    show: Boolean,
    onCancel: Function,
    itemData: Object,
    currentCurrency: String,
    items: Array,
  },
  data() {
    return {
      item: {
        deliveryDate: "",
        name: "",
        weight: "",
        weightUOM: "kg",
        quantity: "",
        // logisticsType: "",
        price: "",
        description: "",
      },
      isEdit: false,
      isOpen: false,
      isOpenCurrency: false,
      currency: this.currentCurrency,
      currencies: [
        {
          name: "Naira",
          code: "NGN",
          flag: NaijaFlag,
        },
        {
          name: "Kenya Shilling",
          code: "KES",
          flag: KenyaFlag,
        },
        {
          name: "US Dollar",
          code: "USD",
          flag: UsaFlag,
        },
      ],
      weightUOMList: ["tonnes", "kg", "pallet", "crate", "sqm"],
    };
  },
  methods: {
    handleAddItem() {
      if (this.canUpdateCurrency) {
        this.$emit("update-currency", this.currency);
      }
      if (this.isEdit) {
        this.$emit("edit-item", this.item);
        return;
      }
      this.$emit("add-item", this.item);
    },
    IsNumber(event) {
      if (!/^[0-9]\d*(\.\d+)?$/.test(event.key)) return event.preventDefault();
    },
    closeWeightUom() {
      this.isOpen = false;
    },
    closeCurrency() {
      this.isOpenCurrency = false;
    },
    toggleCurrency() {
      if (this.canUpdateCurrency) this.isOpenCurrency = !this.isOpenCurrency;
    },
  },
  computed: {
    minDeliveryDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now
        .getDate()
        .toString()
        .padStart(2, "0");
      const hours = now
        .getHours()
        .toString()
        .padStart(2, "0");
      const minutes = now
        .getMinutes()
        .toString()
        .padStart(2, "0");

      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },
    currentFlag() {
      if (!this.currency) return;

      const currentCurrency = this.currencies.find(
        (currency) => currency.code === this.currency
      );
      return currentCurrency.flag;
    },
    canUpdateCurrency() {
      return (
        (this.isEdit && this.itemData.id === 1) ||
        this.items.length === 0 ||
        this.isFirstItemInItems
      );
    },
    isFirstItemInItems() {
      if (!this.itemData || !this.itemData.id) return false;
      return this.items.length > 0 && this.itemData.id === this.items[0].id;
    },
  },
  watch: {
    itemData: {
      handler(val) {
        if (val.name) {
          this.isEdit = true;
          this.item = { ...val };
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style scoped>
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Hide arrows in input type number for Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.dropdown-unit {
  top: 55%;
  right: 10px;
  column-gap: 5px;
}

.dropdown {
  position: relative;
  width: 200px;
}

.dropdown-selected {
  display: flex;
  align-items: center;
  padding: 10px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
}

.flag-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.dropdown-list {
  position: absolute;
  top: 100%;
  /* left: 0; */
  right: 0;
  background: white;
  /* border: 1px solid #ccc; */
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 5px;
  padding: 0;
  list-style: none;
  z-index: 10;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  transition: background 0.3s;
}

.dropdown-item:hover {
  background: #f0f0f0;
}

.dropdown-item .flag-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
</style>
